const ROW_SELECTOR = '.paper-row, .paper-card, .daily-row, .daily-card, .daily-todo-row, .recent-row, .recent-card, .global-search-row, .global-search-card'

function consumeRowClick(event) {
  event.preventDefault()
  event.stopImmediatePropagation()
}

export function createPcRowActionMenuMixin(menus) {
  return {
    mounted() {
      document.addEventListener('click', this.handlePcRowActionMenuClickCapture, true)
      document.addEventListener('dblclick', this.handlePcRowActionMenuClickCapture, true)
    },
    beforeDestroy() {
      document.removeEventListener('click', this.handlePcRowActionMenuClickCapture, true)
      document.removeEventListener('dblclick', this.handlePcRowActionMenuClickCapture, true)
      this._pcMenuDismissedRow = null
    },
    methods: {
      handlePcRowActionMenuClickCapture(event) {
        const target = event.target && (event.target.nodeType === 1 ? event.target : event.target.parentElement)
        const root = this.$el
        if (!target || !target.closest || !root || !root.contains) {
          return
        }

        const row = target.closest(ROW_SELECTOR)
        const ownRow = row && root.contains(row) ? row : null
        // A double-click that starts by dismissing a menu must not open the row.
        if (this._pcMenuDismissedRow) {
          if (event.detail > 1 && ownRow === this._pcMenuDismissedRow) {
            consumeRowClick(event)
            return
          }
          this._pcMenuDismissedRow = null
        }
        if (event.type !== 'click') {
          return
        }

        menus.forEach(menu => {
          if (this[menu.state] === '' || this[menu.state] === null || this[menu.state] === undefined) {
            return
          }
          const activeMenu = root.querySelector(menu.selector)
          if (!activeMenu || activeMenu.contains(target)) {
            return
          }
          // Keep the existing toggle and direct switch between row menus.
          const trigger = target.closest(menu.trigger)
          if (trigger && root.contains(trigger)) {
            return
          }

          this[menu.state] = ''
          if (ownRow) {
            // Preserve the workspace's normal closing of filter/sort menus.
            if (menu.close && typeof this[menu.close] === 'function') {
              this[menu.close]()
            }
            this._pcMenuDismissedRow = ownRow
            consumeRowClick(event)
          }
        })
      }
    }
  }
}

export default createPcRowActionMenuMixin([
  { state: 'moreMenuId', selector: '.paper-more-menu', trigger: '.paper-more-button', close: 'closeFloatingMenus' }
])
